<div class="logo">
  <img *ngIf="logoUrl" [src]="logoUrl" [alt]="altText" class="redIcon" />
</div>
